/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Money_CollectInputs */

const en_features_money_collect = /** @type {(inputs: Features_Money_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€80`)
};

const pl_features_money_collect = /** @type {(inputs: Features_Money_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 zł`)
};

/**
* | output |
* | --- |
* | "€80" |
*
* @param {Features_Money_CollectInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_money_collect = /** @type {((inputs?: Features_Money_CollectInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Money_CollectInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_money_collect(inputs)
	return en_features_money_collect(inputs)
});